import React from 'react';

const AJAX_PHP = () => {
  return (
    <div >
      <h1>AJAX_PHP</h1>
      <p>Placeholder component for: "AJAX PHP"</p>
    </div>
  );
};

export default AJAX_PHP;
